module.exports = __webpack_public_path__ + "static/media/stoped.053deeae.svg";